export function getDefaultShareText(firstName?: string): string {
  const name = firstName || 'Somebody';
  return `${name} has shared a secure document with you from the DocuWalk system. Please follow the link to view.`;
}
